import Component from '@glimmer/component';

import { service } from '@ember/service';

export default class ListLevelsComponent extends Component {
  @service session;

  get livelliSci() {
    const livelli_sci = this.session.option_field?.livelli_sci || [];
    const item = this.args.item;

    if (item?.is_sci || (!item?.is_fondo && !item?.is_snow)) {
      return livelli_sci.filter((l) => !l.hide_ecommerce && !l.hideSci);
    }

    return [];
  }

  get livelliSnow() {
    const livelli_sci = this.session.option_field?.livelli_sci || [];
    const item = this.args.item;

    if (item?.is_snow) {
      return livelli_sci.filter((l) => !l.hide_ecommerce && l.isSnowboard);
    }

    return [];
  }

  get livelliFondo() {
    const livelli_sci = this.session.option_field?.livelli_sci || [];
    const item = this.args.item;

    if (item?.is_fondo) {
      return livelli_sci.filter((l) => !l.hide_ecommerce && l.isFondo);
    }

    return [];
  }
}
